<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system';
	import PremiumUpsellAlert from 'src/components/Premium/PremiumUpsellAlert.svelte';
	import { user_data } from 'src/stores/account/user';
import { notify_alexa } from 'src/stores/lists/scenes-derived';
	import { _init_notifications } from '../../../../../../../helpers/init_notification_actions';
	import { getContext } from 'svelte';

	export let sceneData: any;

	let isGoToPremium: SvelteStore<any> = getContext('go_to_premium');

	let message = $format('alert_alexa_notification_max', {
		values: {
			max: $notify_alexa._max,
			number_of_free: $notify_alexa._max - $notify_alexa._active_cnt,
		},
	});
</script>

<!-- <Tooltip
	class="mt-m mb-m"
	placement="top"
	title={`Action allowed if the constraints are met`}
	> -->
<!-- svelte-ignore missing-declaration -->
<!-- <div class="mb-l">
	<Text element="p" styleType="body-small">
		* {title}
	</Text>
</div> -->
<!-- </Tooltip> -->

{#if sceneData.notificationAction.already_in_current_scene}
	<Alert
		class="mt-l"
		message={$format('info_msg_already_set_that_scene_action', {
			default: `You have already set that action for the scene.`,
		})}
		type="warning"
		heading={$format('title_alredy_exist', { default: 'Already exist' })}
	/>
{:else}
	<Alert
		class="mt-l"
		{message}
		type={$notify_alexa._active_cnt === $notify_alexa._max ? 'danger' : 'info'}
		heading={$format('title_count_constraint', {
			default: 'Count constaraint',
		})}
	/>

	{#if !$user_data.premium}
		<PremiumUpsellAlert
			class="mt-s"
			heading={$format('alert_heading_alexa_notifications_limit', {
				default: `You have a limit from 3 scenes per account with "Notify Alexa" action. Upgrade to Premium to increase them up to 100 .`,
			})}
			navigate={false}
			onGetPremium={() => ($isGoToPremium = true)}
		/>
	{/if}
{/if}

<!-- <Alert
	class="mt-m mb-m"
	message={`This action allowed if "Allowed for Voice Assistants" setting disabled`}
	type={scene_object._meta.integrations ? 'danger' : 'info'}
	heading="Settings constaraintion"
/> -->
